/**
 * @flow
 * @relayHash f1c527e509be4c026c1afe451361eb7b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EnableTwoFactorMutationVariables = {||};
export type EnableTwoFactorMutationResponse = {|
  +enableTwoFactor: {|
    +twoFactorEnabled: boolean
  |}
|};
export type EnableTwoFactorMutation = {|
  variables: EnableTwoFactorMutationVariables,
  response: EnableTwoFactorMutationResponse,
|};
*/


/*
mutation EnableTwoFactorMutation {
  enableTwoFactor {
    twoFactorEnabled
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "enableTwoFactor",
    "storageKey": null,
    "args": null,
    "concreteType": "EnableTwoFactorPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "twoFactorEnabled",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EnableTwoFactorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EnableTwoFactorMutation",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EnableTwoFactorMutation",
    "id": null,
    "text": "mutation EnableTwoFactorMutation {\n  enableTwoFactor {\n    twoFactorEnabled\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ddb70a3f650c98af3163a0afc626d09c';
module.exports = node;
